export default "__VITE_ASSET__vwhYOc3q__"